import { ImageCell } from './ImageCell';
import { TextAreaViewCell } from './TextAreaViewCell';
import { StatusChip } from './StatusChip';

export const generateColumns = (isMobile, ActionButtons, handleImageClick) =>
  [
    {
      field: 'manufacturer',
      headerName: 'Brand',
      editable: false,
      minWidth: 120,
    },
    {
      field: 'category',
      headerName: 'Category',
      editable: false,
      flex: 1,
      minWidth: isMobile ? 150 : 130,
    },
    {
      field: 'mpn',
      headerName: 'MPN',
      editable: false,
      flex: 0.6,
      minWidth: 130,

      // minWidth: isMobile ? 150 : 130,
      renderCell: (params) => <TextAreaViewCell isBold {...params} />,
    },
    {
      field: 'name',
      headerName: 'Title',
      align: 'left',
      headerAlign: 'left',
      editable: false,
      flex: 1,
      minWidth: 130,
      // renderEditCell: (params) => <TextAreaEditCell {...params} />,
      renderCell: (params) => <TextAreaViewCell {...params} />,
    },
    {
      field: 'sku',
      headerName: 'SKU',
      align: 'left',
      headerAlign: 'left',
      editable: false,
      // flex: 1,
      minWidth: isMobile ? 150 : 140,
      // renderCell: (params) => <div style={{ fontWeight: 'bold' }}>{params.value}</div>,
    },
    {
      field: 'totalImages',
      headerName: 'Preview',
      align: 'left',
      headerAlign: 'left',
      editable: false,
      filterable: false,
      minWidth: 120,
      renderCell: (params) => <ImageCell params={params} onImgClick={handleImageClick} />,
    },
    {
      field: 'color',
      headerName: 'Color',
      editable: false,
      // flex: 1,
      minWidth: isMobile ? 160 : 120,
    },
    {
      field: 'status',
      headerName: 'Status',
      editable: false,
      renderCell: (params) => <StatusChip params={params} />,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Edit variants',
      cellClassName: 'actions',
      getActions: ({ row }) => [<ActionButtons row={row} />],
      flex: 0.6,
      minWidth: 110,
    },
  ].filter(Boolean); // Filter to remove any undefined values
